import { Alert, Button } from "@mui/material";
import React from "react";
import { useGlobalState } from "../components/globalState";
import { useAuth } from "../context/AuthContext";

export const ImpersonationBanner: React.FC = () => {
	const { isImpersonating, stopImpersonating } = useAuth();
	const { currentUser } = useGlobalState();

	if (!isImpersonating) return null;

	return (
		<Alert
			severity="warning"
			action={
				<Button color="inherit" size="small" onClick={stopImpersonating}>
					Exit Impersonation
				</Button>
			}
		>
			You are currently impersonating {currentUser?.username}
		</Alert>
	);
};
